import React from "react";
import QuestionWrapper from "./QuestionWrapper";
import TextArea from "textarea-autosize-reactjs";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { CustomDialog } from "../../../components/DialogCollection";
import "./style.scss";

const ListQuestion = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const {
    setResult,
    result,
    submitSurvey,
    isModal,
    setIsModal,
    isValidateModal,
    setIsValidateModal,
    surveyDetail,
  } = props;
  const questions = props.data;

  const handleOtherAnswerType4 = (e, id, type) => {
    let input = e.target.value;
    if (input.length > 0) {
      let data = {
        answer: e.target.value,
        id: id,
        type: 4,
        isInput: true,
      };
      let resultAns = [...result];
      let checkState = resultAns.filter(
        (a) => a.id == id && a.type == type && a.isInput == true
      );
      if (checkState.length > 0) {
        let searchIdx = resultAns.findIndex(
          (a) => a.id == id && a.type == type && a.isInput == true
        );
        resultAns[searchIdx].answer = e.target.value;
        setResult(resultAns);
      } else {
        resultAns.push(data);
        setResult(resultAns);
      }
    } else {
      let resultAns = [...result];
      let searchIdx = resultAns.findIndex(
        (a) => a.id == id && a.type == type && a.isInput == true
      );
      resultAns.splice(searchIdx, 1);
      setResult(resultAns);
    }
  };

  const handleMultiAnswer = (payload, id, type) => {
    let data = {
      answer: payload,
      id: id,
      type: type,
    };
    let resultAns = [...result];
    let checkState = resultAns.filter(
      (a) => a.id == id && a.answer == payload && a.type == type
    );
    if (checkState.length > 0) {
      let searchIdx = resultAns.findIndex(
        (a) => a.id == id && a.answer == payload && a.type == type
      );
      resultAns.splice(searchIdx, 1);
      setResult(resultAns);
    } else {
      resultAns.push(data);
      setResult(resultAns);
    }
  };

  const handleAnswerFreeText = (payload, id, type) => {
    let data;
    let input = payload.target.value;
    if (input.length > 0) {
      data = {
        answer: payload.target.value,
        id: id,
      };
      let resultAns = [...result];
      let checkState = resultAns.filter((a) => a.id == id);
      if (checkState.length > 0) {
        let searchIdx = resultAns.findIndex((a) => a.id == id);
        resultAns.splice(searchIdx, 1);
        resultAns.push(data);
        setResult(resultAns);
      } else {
        resultAns.push(data);
        setResult(resultAns);
      }
    } else {
      let resultAns = [...result];
      let searchIdx = resultAns.findIndex((a) => a.id == id);
      resultAns.splice(searchIdx, 1);
      setResult(resultAns);
    }
  };

  const handleAnswer = (payload, id, type) => {
    let data;
    if (type == 0) {
      data = {
        answer: payload.target.value,
        id: id,
      };
    }
    if (type == 1 || type == 2) {
      data = {
        answer: payload,
        id: id,
      };
    }
    let resultAns = [...result];
    let checkState = resultAns.filter((a) => a.id == id);
    if (checkState.length > 0) {
      let searchIdx = resultAns.findIndex((a) => a.id == id);
      resultAns.splice(searchIdx, 1);
      resultAns.push(data);
      setResult(resultAns);
    } else {
      resultAns.push(data);
      setResult(resultAns);
    }
  };

  const getDataType34 = () => {
    let filterResult = result.filter((a) => a.type == 3 || a.type == 4);
    let unique = [...new Set(filterResult.map((item) => item.id))];
    let resultData = [];
    for (let i = 0; i < unique.length; i++) {
      let getData = result.filter((a) => a.id == unique[i]);
      let getAnswer = getData.map((a) => a.answer);
      let mergedAnswer = getAnswer.join("|");
      let postData = {
        answer: mergedAnswer,
        id: getData[0].id,
      };
      resultData.push(postData);
    }

    return resultData;
  };

  const handleSubmit = async () => {
    let dataType34 = await getDataType34();
    let dataPost = result.filter((a) => a.type !== 3 && a.type !== 4);
    let mergedDataPost = dataPost.concat(dataType34);
    if (mergedDataPost.length !== questions.length) {
      setIsValidateModal(true);
    } else {
      const { status } = await submitSurvey({
        id: params.surveyId,
        data: {
          answers: mergedDataPost,
        },
      });
      if (status == 200) {
        setIsModal(true);
      }
    }
  };

  return (
    <>
      {questions &&
        questions.map((question, index) => (
          <div key={index}>
            {/* Type 0 => FreeText */}
            {question.type == 0 && (
              <QuestionWrapper
                title={question.title}
                content={
                  <TextArea
                    placeholder="Answer"
                    className="free-text"
                    onChange={(e) => handleAnswerFreeText(e, question.id, 0)}
                  />
                }
              />
            )}
            {/* Type 1 => Single Choice */}
            {question.type == 1 && (
              <QuestionWrapper
                title={question.title}
                content={
                  question.options &&
                  question.options.map((a, index) => (
                    <div
                      className={
                        result.filter(
                          (b) => b.answer == a.option && b.id == question.id
                        ).length > 0
                          ? "btn card-answer active"
                          : "btn card-answer"
                      }
                      key={index}
                      onClick={() =>
                        handleAnswer(
                          question.options[index].option,
                          question.id,
                          1
                        )
                      }
                    >
                      <Row>
                        <Col md={10} sm={10} xs={10} className="text-start">
                          <span
                            className={
                              result.filter(
                                (b) =>
                                  b.answer == a.option && b.id == question.id
                              ).length > 0
                                ? "text-active"
                                : ""
                            }
                          >
                            {a.option}
                          </span>
                        </Col>
                        <Col
                          md={2}
                          sm={2}
                          xs={2}
                          className={
                            result.filter(
                              (b) => b.answer == a.option && b.id == question.id
                            ).length > 0
                              ? "icon-wrapper"
                              : "icon-wrapper-none"
                          }
                        >
                          <img src={Assets.iconCheckSurvey} alt="logo_image" />
                        </Col>
                      </Row>
                    </div>
                  ))
                }
              />
            )}
            {/* Type 2 = Boolean */}
            {question.type == 2 && (
              <QuestionWrapper
                title={question.title}
                content={
                  <div className="answer-wrapper">
                    {question.options &&
                      question.options.map((a, index) => (
                        <div
                          className={
                            result.filter(
                              (b) => b.answer == a.option && b.id == question.id
                            ).length > 0
                              ? "btn answer-button active"
                              : "btn answer-button"
                          }
                          key={index}
                          onClick={() =>
                            handleAnswer(
                              question.options[index].option,
                              question.id,
                              2
                            )
                          }
                        >
                          {a.option}
                        </div>
                      ))}
                  </div>
                }
              />
            )}
            {/* Type 3 = Multiple Choice */}
            {question.type == 3 && (
              <QuestionWrapper
                title={question.title}
                content={
                  question.options &&
                  question.options.map((a, index) => (
                    <div
                      className={
                        result.filter(
                          (b) => b.answer == a.option && b.id == question.id
                        ).length > 0
                          ? "btn card-answer active"
                          : "btn card-answer"
                      }
                      key={index}
                      onClick={() =>
                        handleMultiAnswer(
                          question.options[index].option,
                          question.id,
                          3
                        )
                      }
                    >
                      <Row>
                        <Col md={10} sm={10} xs={10} className="text-start">
                          <span
                            className={
                              result.filter(
                                (b) =>
                                  b.answer == a.option && b.id == question.id
                              ).length > 0
                                ? "text-active"
                                : ""
                            }
                          >
                            {a.option}
                          </span>
                        </Col>
                        <Col
                          md={2}
                          sm={2}
                          xs={2}
                          className={
                            result.filter(
                              (b) => b.answer == a.option && b.id == question.id
                            ).length > 0
                              ? "icon-wrapper"
                              : "icon-wrapper-none"
                          }
                        >
                          <img src={Assets.iconCheckSurvey} alt="logo_image" />
                        </Col>
                      </Row>
                    </div>
                  ))
                }
              />
            )}
            {question.type == 4 && (
              <QuestionWrapper
                title={question.title}
                content={
                  <>
                    {question.options &&
                      question.options.map((a, index) => (
                        <div
                          className={
                            result.filter(
                              (b) => b.answer == a.option && b.id == question.id
                            ).length > 0
                              ? "btn card-answer active"
                              : "btn card-answer"
                          }
                          key={index}
                          onClick={() =>
                            handleMultiAnswer(
                              question.options[index].option,
                              question.id,
                              4
                            )
                          }
                        >
                          <Row>
                            <Col md={10} sm={10} xs={10} className="text-start">
                              <span
                                className={
                                  result.filter(
                                    (b) =>
                                      b.answer == a.option &&
                                      b.id == question.id
                                  ).length > 0
                                    ? "text-active"
                                    : ""
                                }
                              >
                                {a.option}
                              </span>
                            </Col>
                            <Col
                              md={2}
                              sm={2}
                              xs={2}
                              className={
                                result.filter(
                                  (b) =>
                                    b.answer == a.option && b.id == question.id
                                ).length > 0
                                  ? "icon-wrapper"
                                  : "icon-wrapper-none"
                              }
                            >
                              <img
                                src={Assets.iconCheckSurvey}
                                alt="logo_image"
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    {question.options &&
                      question.options
                        .filter((_, i) => i >= 1 && i < 2)
                        .map((a, index) => (
                          <div
                            className={
                              result.filter(
                                (b) => b.id == question.id && b.isInput == true
                              ).length > 0
                                ? "btn card-answer active-input"
                                : "btn card-answer"
                            }
                            key={index}
                            id="4input-wrapper"
                          >
                            <Row>
                              <TextArea
                                placeholder="Other: Type answer"
                                className="textarea-type4"
                                onChange={(e) =>
                                  handleOtherAnswerType4(e, question.id, 4)
                                }
                              />
                            </Row>
                          </div>
                        ))}
                  </>
                }
              />
            )}
          </div>
        ))}
      <div className="survey-submit">
        <Button className="submit-button" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
      <CustomDialog
        show={isModal}
        title="Thank You"
        onHide={() => navigate(PageRoutes.survey)}
        buttonText="Done"
        content={
          <div>
            <span>Thank you for participating.</span>
            <div>
              <span>You have received a reward of</span>
            </div>
            <div className="card-survey">
              <img src={Assets.iconGoldCoin} alt="logo_image" />
              <div className="point-wrapper">
                <span className="survey-text">
                  {surveyDetail.points} {surveyDetail.currency.name}
                </span>
              </div>
            </div>
          </div>
        }
      />
      <CustomDialog
        show={isValidateModal}
        title="Information"
        onHide={() => setIsValidateModal(false)}
        buttonText="OK"
        content={
          <div>
            <span>You haven't answered all the questions in the survey</span>
          </div>
        }
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  surveyDetail: state.SurveySM.surveyDetail,
});

const mapDispatchToProps = (dispatch) => ({
  submitSurvey: dispatch.SurveySM.submitSurvey,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListQuestion);
